import axios from "@/api/axiosInstance";
import type { GetTestCompanySchemaResponse } from "./types";

export const getTestCompanySchema =
  async (): Promise<GetTestCompanySchemaResponse> => {
    const response = await axios.get<GetTestCompanySchemaResponse>(
      "/api/private/admin/test-companies/schema",
    );
    return response.data;
  };
